import React, { useEffect, useState } from 'react';
import { fetchGet } from '../../api/common';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
  AppBar,
  Box,
  Button,
  Container,
  FormControlLabel,
  FormGroup,
  IconButton,
  Stack,
  Switch,
  Toolbar,
  Typography,
} from '@mui/material';
import { QuestionStats } from '../room/types';
import { utcToLocalDateTime } from '../room/utils';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { Profile } from '@par/shared/types/player';

export interface Flashcard {
  createdAt: number;
  notes: string;
  question: string;
  questionId: string;
  answer: string;
  par: number;
  category: string;
}

type PropTypes = {
  flashcards?: Flashcard[];
  profile: Profile;
  updateFlashcards: (flashcards: Flashcard[]) => void;
};

export const Flashcards = ({
  flashcards,
  profile,
  updateFlashcards,
}: PropTypes) => {
  const navigate = useNavigate();
  const [hideAnswers, setHideAnswers] = useState(true);
  const [openQuestionStatsDialog, setOpenQuestionStatsDialog] = useState(false);
  const [questionStats, setQuestionStats] = useState<QuestionStats>();
  const [selectedFlashcard, setSelectedFlashcard] = useState<Flashcard>();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res: Flashcard[] = await fetchGet(
      `/flashcards/profile/${profile.id}`
    );
    updateFlashcards(res);
  };

  const handleLaunchFlashcardModeClick = () => {
    navigate('/study');
  };

  const handleStatsClick = async (flashcard: Flashcard) => {
    const res: QuestionStats = await fetchGet(
      `/question-stats/questionId/${flashcard.questionId}`
    );
    setQuestionStats(res);
    setSelectedFlashcard(flashcard);
    setOpenQuestionStatsDialog(true);
  };

  return (
    <>
      {/* <QuestionStatsDialog
        onClose={() => setOpenQuestionStatsDialog(false)}
        open={openQuestionStatsDialog}
        flashcard={selectedFlashcard}
        questionStats={questionStats}
      ></QuestionStatsDialog> */}
      <Container sx={{ paddingBottom: '100px' }}>
        <Typography variant="h4" textAlign={'center'} letterSpacing={2} mb={2}>
          Flashcards
        </Typography>
        <Box sx={{ flexGrow: 1, marginBottom: 2 }}>
          <AppBar position="static">
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                disabled
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                (...in development)
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleLaunchFlashcardModeClick}
                >
                  Launch Flashcard Mode
                </Button>
                <Button variant="outlined" color="primary" disabled>
                  Launch PAR Mode
                </Button>
              </Stack>
            </Toolbar>
          </AppBar>
        </Box>
        <Stack direction={'row'}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={hideAnswers}
                  onChange={() => setHideAnswers((prev) => !prev)}
                />
              }
              label="Hide Answers"
              labelPlacement="start"
            />
          </FormGroup>
        </Stack>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell width={'40%'}>Question</TableCell>
                <TableCell width={'15%'}>Answer</TableCell>
                <TableCell width={'15%'}>Category</TableCell>
                <TableCell>PAR</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell width={'5%'}>Stats</TableCell>
                <TableCell width={'5%'}>Saved At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {flashcards?.map((card, index) => (
                <TableRow key={card.question}>
                  <TableCell>{card.question}</TableCell>
                  <TableCell>
                    {hideAnswers ? '[hidden]' : card.answer}
                  </TableCell>
                  <TableCell>{card.category}</TableCell>
                  <TableCell>{card.par}</TableCell>
                  <TableCell>{card.notes}</TableCell>
                  <TableCell>
                    <Button
                      variant="text"
                      onClick={() => handleStatsClick(card)}
                    >
                      ...
                    </Button>
                  </TableCell>
                  <TableCell>{utcToLocalDateTime(card.createdAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};
